import { defineFetch } from 'resift';

interface UpdateRolePermissionRequest {
  scopeFilter: any;
}

const makeUpdateRolePermission = defineFetch({
  displayName: 'Update Role Permission',
  make: (roleId: string, permissionId: string) => ({
    request: (data: UpdateRolePermissionRequest) => ({ http }) =>
      http({
        method: 'PUT',
        route: `/roles/${roleId}/permissions/${permissionId}`,
        data,
      }),
  }),
});

export default makeUpdateRolePermission;
